/**
 * @generated SignedSource<<0a88bd483fe2798139c9deba0ed100ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type EventType = "OCCURRENCE" | "RECURRING" | "SINGLE";
export type GenericInviteQuery$variables = {
  end: string;
  excludeConfigured: boolean;
  excludeExternal: boolean;
  excludeInactive: boolean;
  start: string;
};
export type GenericInviteQuery$data = {
  readonly viewer: {
    readonly events: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly attendees: ReadonlyArray<{
            readonly email: string;
          } | null>;
          readonly id: string;
          readonly isOneOnOne: boolean;
          readonly recurrenceRule: ReadonlyArray<string | null> | null;
          readonly start: string | null;
          readonly type: EventType;
        };
      } | null>;
    };
    readonly foundContacts: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly email: string;
          readonly fullName: string;
          readonly groupSize: number | null;
          readonly id: string;
          readonly image: string;
          readonly isGroup: boolean;
          readonly user: {
            readonly email: string;
            readonly firstName: string;
            readonly id: string;
            readonly internalAttributes: {
              readonly oneOnOneWithViewer: {
                readonly archived: boolean | null;
                readonly id: string;
              } | null;
            } | null;
            readonly isActive: boolean;
            readonly isConfigured: boolean;
            readonly isGuest: boolean;
          } | null;
        } | null;
      } | null>;
    } | null;
    readonly id: string;
    readonly personalInviteLink: {
      readonly id: string;
      readonly inviteLink: string;
      readonly isEnabled: boolean;
    };
  };
};
export type GenericInviteQuery = {
  response: GenericInviteQuery$data;
  variables: GenericInviteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "end"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeConfigured"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeExternal"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeInactive"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "start"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "PersonalInviteLink",
  "kind": "LinkedField",
  "name": "personalInviteLink",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inviteLink",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "end",
      "variableName": "end"
    },
    {
      "kind": "Variable",
      "name": "start",
      "variableName": "start"
    }
  ],
  "concreteType": "EventConnection",
  "kind": "LinkedField",
  "name": "events",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "start",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "recurrenceRule",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isOneOnOne",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Attendee",
              "kind": "LinkedField",
              "name": "attendees",
              "plural": true,
              "selections": [
                (v7/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "excludeConfigured",
    "variableName": "excludeConfigured"
  },
  {
    "kind": "Variable",
    "name": "excludeExternal",
    "variableName": "excludeExternal"
  },
  {
    "kind": "Literal",
    "name": "excludeGroups",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "excludeInactive",
    "variableName": "excludeInactive"
  },
  {
    "kind": "Literal",
    "name": "ranked",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "search",
    "value": ""
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGroup",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupSize",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConfigured",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStream",
  "kind": "LinkedField",
  "name": "oneOnOneWithViewer",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archived",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GenericInviteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          {
            "alias": "foundContacts",
            "args": (v9/*: any*/),
            "concreteType": "ContactNodeConnection",
            "kind": "LinkedField",
            "name": "contacts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContactNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContactNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v10/*: any*/),
                      (v7/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v7/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserInternalAttributes",
                            "kind": "LinkedField",
                            "name": "internalAttributes",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "GenericInviteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          {
            "alias": "foundContacts",
            "args": (v9/*: any*/),
            "concreteType": "ContactNodeConnection",
            "kind": "LinkedField",
            "name": "contacts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContactNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContactNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v10/*: any*/),
                      (v7/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v7/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserInternalAttributes",
                            "kind": "LinkedField",
                            "name": "internalAttributes",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0c0fd1f4f05ab8e6908f564437dd1897",
    "id": null,
    "metadata": {},
    "name": "GenericInviteQuery",
    "operationKind": "query",
    "text": "query GenericInviteQuery(\n  $start: DateTime!\n  $end: DateTime!\n  $excludeConfigured: Boolean!\n  $excludeExternal: Boolean!\n  $excludeInactive: Boolean!\n) {\n  viewer {\n    id\n    personalInviteLink {\n      id\n      isEnabled\n      inviteLink\n    }\n    events(start: $start, end: $end) {\n      edges {\n        node {\n          id\n          type\n          start\n          recurrenceRule\n          isOneOnOne\n          attendees {\n            email\n          }\n        }\n      }\n    }\n    foundContacts: contacts(ranked: true, search: \"\", excludeConfigured: $excludeConfigured, excludeExternal: $excludeExternal, excludeInactive: $excludeInactive, excludeGroups: true) {\n      edges {\n        node {\n          id\n          fullName\n          email\n          image\n          isGroup\n          groupSize\n          user {\n            id\n            email\n            firstName\n            isActive\n            isConfigured\n            isGuest\n            internalAttributes {\n              oneOnOneWithViewer {\n                id\n                archived\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9bba389c1e379741f26669e2d4fd7fdb";

export default node;
